
import React from 'react';
import moment from 'moment';
import LazyLoad from 'react-lazyload';
import StarScore from '../../StarScore';
import {Desc} from '../Desc';
import {Webp} from '../formateImage';

const SOURCE = {
  'qyer': '穷游',
  'mafengwo': '蚂蜂窝'
};

export default function Item(props){
  let { showBigImage } = props;
  let {source,comment_time, grade, user_info,content, pic_list,} = props.item;
  let time = moment(comment_time*1000).format('YYYY/MM/DD');
  
  let avatar = user_info.avatar.indexOf('img.zuzuche.com') > -1 ? user_info.avatar : Webp(`${user_info.avatar}!/sq/70`);
  return (
    <li className="comment-item">
      <div className="item-inner">
        <div className="comment-user">
          <div className="avatar">
            <img src={avatar} alt={user_info.nickname}/>
          </div>
          <div className="name">
            <p>{user_info.nickname}</p>
            <span>来自{SOURCE[source]}   {time}</span>
          </div>
          <StarScore score={Number(grade)} className="comment-start"/>
        </div>
        <Desc 
          className="comment-content" 
          desc={content} 
          number={136}/>
        <div className="comment-pics-wrap">
          {
            pic_list && pic_list.length ?
              <ul className="comment-pics">
                {
                  pic_list.map((pic,index)=>{
                    if(index < 3){
                      let formatImage = `${pic.url}!/both/215x215`;
                      formatImage = Webp(formatImage);
                      return (<LazyLoad height={50} key={index}>
                        <li 
                          key={index}
                          onClick={()=>{
                            showBigImage(index, pic_list);
                          }}>
                          <img src={formatImage} alt="评论图片"/>
                        </li>
                      </LazyLoad>);
                    }
                  })
                }
              </ul>
              : null
          }
          { pic_list && pic_list.length > 3 ? <span className="total">共{pic_list.length}张</span> : null}
        </div>
       
      </div>
    </li>
  );
}




// WEBPACK FOOTER //
// ./src/components/Poi2/Comment/CommentItem.js